import React, { PureComponent } from "react";
import FaqsDashboard from "../component/FaqsDashboard";

export class Faqs extends PureComponent {
  render() {
    return (
      <div>
        <FaqsDashboard />
      </div>
    );
  }
}

export default Faqs;
